import { App } from 'vue'
import Find from './Find.vue'

const register = (app: App<Element>): void => {
  app
    .component('certificate-find', Find)
}

export default {
  register,
}
